import { Flex, Text, Box } from '@chakra-ui/react';

import CloseIconComponent from 'components/Icons/CloseIcon';

import ToastStatusIcon from './ToastStatusIcon';

interface Properties {
  title: string;
  description?: string;
  status: 'success' | 'error';
  onClose: () => void;
}

/** Dark themed toast body used with Chakra's `useToast({ render: ... })`. */
const StyledToast = ({ title, description, status, onClose }: Properties) => {
  return (
    <Flex
      align='flex-start'
      gap='11px'
      py='14px'
      pl='16px'
      pr='14px'
      borderRadius='12px'
      bgColor='#121826'
      boxShadow='0px 8px 24px rgba(0, 0, 0, 0.24)'
      maxW='360px'
    >
      <Box flexShrink={0} mt='1px'>
        <ToastStatusIcon status={status} size={22} />
      </Box>

      <Box flex='1'>
        <Text fontFamily='Roboto Bold' fontWeight='700' fontSize='14px' color='white'>
          {title}
        </Text>
        {description && (
          <Text
            fontFamily='Roboto Regular'
            fontWeight='400'
            fontSize='13px'
            color='#BEBEBE'
            mt='2px'
          >
            {description}
          </Text>
        )}
      </Box>

      <Box mt='4px' flexShrink={0}>
        <CloseIconComponent height={'11px'} width={'11px'} color={'#708090'} onClick={onClose} />
      </Box>
    </Flex>
  );
};

export default StyledToast;
